import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'dialog-input',
    templateUrl: './dialog-input.component.html',
    styleUrls: ['./dialog-input.component.scss'],
})
export class DialogInputComponent implements OnInit {
    ngOnInit(): void {}
    valor: number;

    constructor(public dialogRef: MatDialogRef<DialogInputComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.valor = data.valor;
    }
    confirm() {
        this.dialogRef.close(this.valor);
    }
}
